import { Component } from '@theme/component';
import { CompareList } from '@theme/compare-list';

class CompareTrayComponent extends Component {
  requiredRefs = ['count', 'thumbs'];

  connectedCallback() {
    super.connectedCallback();
    this.#render();
    document.addEventListener('compare-list:update', this.#render);
  }

  disconnectedCallback() {
    document.removeEventListener('compare-list:update', this.#render);
  }

  clear() {
    CompareList.clear();
  }

  /** @param {PointerEvent} event */
  removeThumb(event) {
    const id = event.currentTarget.dataset.productId;
    if (id) CompareList.removeProduct(id);
  }

  #render = () => {
    const ids = CompareList.getProducts();
    const count = ids.length;

    this.hidden = count === 0;
    this.refs.count.textContent = `${count} of ${CompareList.maxProducts}`;

    this.refs.thumbs.innerHTML = '';
    for (const id of ids) {
      const meta = CompareList.getMetaFor(id);
      const el = document.createElement(meta && meta.image ? 'img' : 'span');
      el.className = meta && meta.image ? 'compare-tray__thumb' : 'compare-tray__thumb compare-tray__thumb-placeholder';
      el.dataset.productId = id;
      el.title = `Remove ${meta && meta.title ? meta.title : 'product'} from comparison`;
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.addEventListener('click', (e) => this.removeThumb(e));
      if (meta && meta.image) {
        el.src = meta.image;
        el.alt = meta.title || '';
      }
      this.refs.thumbs.appendChild(el);
    }
  };
}

if (!customElements.get('compare-tray-component')) {
  customElements.define('compare-tray-component', CompareTrayComponent);
}
